import { compose, withHandlers, withProps } from 'recompose';
import moment from 'moment';
import BarberListTimeTracking from '../components/BarberListTimeTracking';
import withExtendedTimeTracking from '../hoc/withExtendedTimeTracking';
import { formatDuration } from '../selectors';
import showForTimeTrackingEnabled from '../hoc/showForTimeTrackingEnabled';
import withTimeTicker from '../hoc/withTimeTicker';


const BarberListTimeTrackingContainer = compose(
  withExtendedTimeTracking,
  withTimeTicker(),
  withHandlers({
    onClick: props => (e) => {
      e.preventDefault();

      props.setClockedMinutes(0);
      props.onTrackClick();
    },
  }),
  withProps((props) => {
    const [hours, minutes] = props.clockedTime.split(' ');
    const duration = moment
      .duration({
        hours: Number(hours.split('h')[0]),
        minutes: Number(minutes.split('m')[0]),
      })
      .add(props.clockedMinutes, 'm');

    return {
      clockedTime: formatDuration(duration),
    };
  }),
  showForTimeTrackingEnabled,
)(BarberListTimeTracking);

export default BarberListTimeTrackingContainer;
